module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("To my parents, Mildred and Paul Abbey, my brothers"), _c('br'), _vm._v("John, Howard and Bill, and my sister Nancy."), _c('br'), _c('br'), _c('br')])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I write to make a difference. “It is always a writer’s duty to make the world better,” said Samuel Johnson. Distrusting all answers, to raise more questions. To give pleasure and promote esthetic bliss. To honor life and praise the divine beauty of the world. For the joy and exultation of writing itself. To tell my story.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("“Well now,” says the old wolf, "), _c('em', [_vm._v("vox clamantis in deserto")]), _vm._v(", “that should keep him busy for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—E.A.")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539dbde6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 66
// module chunks = 0